import { render, staticRenderFns } from "./ChatService.vue?vue&type=template&id=2b773937&scoped=true&"
import script from "./ChatService.vue?vue&type=script&lang=js&"
export * from "./ChatService.vue?vue&type=script&lang=js&"
import style0 from "./ChatService.vue?vue&type=style&index=0&id=2b773937&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b773937",
  null
  
)

export default component.exports